"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.ModalMount = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Modal.css");
var useDomEvent_1 = require("../../hooks/useDomEvent");
var useInterface_1 = require("../../hooks/useInterface");
var R = __importStar(require("../../utils/ramda"));
var backgroundClick = function (event, onBackgroundClick) {
  if (event.target.matches(".modal")) {
    onBackgroundClick();
  }
};
exports.ModalMount = (0, react_1.forwardRef)(function (_, ref) {
  var _a = __read((0, react_1.useState)(null), 2),
    content = _a[0],
    showModal = _a[1];
  (0, useInterface_1.useInterface)(ref, {
    showModal: showModal
  });
  if (!content) {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
  }
  if (react_1.default.isValidElement(content)) {
    return content;
  }
  return (0, jsx_runtime_1.jsx)(exports.Modal, __assign({}, content));
});
var Modal = function (_a) {
  var headerTitle = _a.headerTitle,
    headerContent = _a.headerContent,
    body = _a.body,
    footer = _a.footer,
    _b = _a.onBackgroundClick,
    onBackgroundClick = _b === void 0 ? R.N : _b,
    _c = _a.onEscapeKeyUp,
    onEscapeKeyUp = _c === void 0 ? R.N : _c,
    className = _a.className,
    children = _a.children,
    restProps = __rest(_a, ["headerTitle", "headerContent", "body", "footer", "onBackgroundClick", "onEscapeKeyUp", "className", "children"]);
  (0, useDomEvent_1.useDomEvent)("keydown", function (event) {
    var e = event;
    if (e.key === "Escape") {
      onEscapeKeyUp(e);
    }
  });
  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(Backdrop, {}), (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
      className: (0, classnames_1.default)("modal", className),
      style: {
        display: "block"
      },
      onClick: function (event) {
        return backgroundClick(event, onBackgroundClick);
      }
    }, {
      children: (0, jsx_runtime_1.jsx)(Dialog, {
        children: (0, jsx_runtime_1.jsxs)(Content, {
          children: [(headerTitle !== null && headerTitle !== void 0 ? headerTitle : headerContent) && (0, jsx_runtime_1.jsx)(Header, __assign({
            title: headerTitle
          }, {
            children: headerContent
          })), (0, jsx_runtime_1.jsxs)(Body, {
            children: [body, children]
          }), footer && (0, jsx_runtime_1.jsx)(Footer, {
            children: footer
          })]
        })
      })
    }))]
  });
};
exports.Modal = Modal;
var Header = function (_a) {
  var title = _a.title,
    children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["title", "children", "className"]);
  return (0, jsx_runtime_1.jsxs)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("modal-header", className)
  }, {
    children: [title && (0, jsx_runtime_1.jsx)("h1", {
      children: title
    }), children]
  }));
};
var Dialog = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("modal-dialog", className)
  }, {
    children: children
  }));
};
var Content = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("modal-content", className)
  }, {
    children: children
  }));
};
var Body = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("modal-body", className)
  }, {
    children: children
  }));
};
var Footer = function (_a) {
  var children = _a.children,
    className = _a.className,
    restProps = __rest(_a, ["children", "className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("modal-footer", className)
  }, {
    children: children
  }));
};
var Backdrop = function (_a) {
  var className = _a.className,
    restProps = __rest(_a, ["className"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: (0, classnames_1.default)("modal-backdrop fade in", className)
  }));
};